import { FieldPath, FieldValues, useWatch } from 'react-hook-form';
import React from 'react';
import { BadgeProps } from 'antd/es/badge';
import { Badge } from 'antd';

export interface FormSegmentLabelCountBadgeProps<
  FormData extends FieldValues,
  Name extends FieldPath<FormData>
> extends BadgeProps {
  name: Name[];
}

export const FormSegmentLabelCountBadge = <
  FormData extends FieldValues,
  Name extends FieldPath<FormData>
>(
  props: FormSegmentLabelCountBadgeProps<FormData, Name>
) => {
  const { name, ...badgeProps } = props;
  const values = useWatch<FormData>({ name });
  const value =
    values.find((val) => Array.isArray(val) && val.length > 0) ?? values?.[0];

  if (!Array.isArray(value)) {
    return null;
  }

  return <Badge count={value.length} {...badgeProps} />;
};
